import React from "react";
import NavigationLink from "./NavigationLink";
import ContactDetails from "./ContactDetails";
import { observer } from "mobx-react";
import { connectoRoles } from "../../utils/constants";

const SecondaryRMCard = ({
  item,
  setTab,
  photo,
  name,
  position,
  phoneNum,
  emailId,
  wrapperClass = "connect_card_outside",
}) => {
  return (
    <div className={wrapperClass}>
      <div className="contact-details-wrapper">
        <ContactDetails
          name={name}
          position={connectoRoles[position]}
          emailId={emailId}
          phoneNum={phoneNum}
        >
          <NavigationLink
            item={item}
            classNameForTeamCard="secondary-rm-1 secondary-rm-full-card-wrapper"
            position={connectoRoles[position]}
          />
        </ContactDetails>
      </div>
    </div>
  );
};

export default observer(SecondaryRMCard);
